(function(algolia) {
  'use strict';
  algolia.translations = {
    search: 'Huidige zoekopdracht',
    noCollectionFound: 'Geen categorieën gevonden',
    allProducts: 'Bekijk alle producten',
    matching: 'matchend',
    sortBy: 'Gesorteerd op',
    relevance: 'Relevantie',
    outOf: 'van',
    resultsFound: 'resultaten gevonden',
    oneResultFound: 'resultaat gevonden',
    noResultFound: 'Geen resultaten gevonden',
    addToCart: 'In winkelwagen',
    searchForProduct: 'Zoek naar producten',
    selectedFilter: 'Gekozen filters',
    clearAll: 'Wis alles',
    noPageFound: 'Geen pagina gevonden',
    outOfStock: 'Niet op voorraad'
  };

  algolia.translation_helpers = {
    no_result_for: function(text, render) {
      return 'Geen resultaten voor zoekopdracht' + render(text);
    },
    in: function() {
      return 'in ' + this.processingTimeMS / 1000 + 's';
    },

    try_clear_or_change_input: function(text, render) {
      var regex = new RegExp(/<\/a>|<a[a-z "-=]*>/, 'g');
      var html_tags = text.match(regex);
      return (
        'Try ' +
        render(html_tags[0]) +
        ' clearing filters ' +
        render(html_tags[1]) +
        ' or ' +
        render(html_tags[2]) +
        ' changing your input ' +
        render(html_tags[3])
      );
    },

    outOf: function() {
      return (
        this.page * this.hitsPerPage +
        1 +
        '-' +
        Math.min((this.page + 1) * this.hitsPerPage, this.nbHits) +
        ' out of'
      );
    },

    by: function(text, render) {
      return 'by ' + render(text);
    },

    translation: function(text, render) {
      return algolia.translations[render(text)];
    },
  };
})(window.algoliaShopify);
